(function () {
'use strict';
/* ═══════════════════════════════════════════════════════════════════════════════
   De Leville · Classico: four ways to choose the size, to compare (Eliau, 7 Oct 2026:
   "the size selector for the classico make it different, better, show me a few ways").

   c is the default (his pick); ?sizer=a|b|d on a Classico page shows another for the visit, ?sizer=0 the theme's own.
     a  Una riga     one line of numbers; the chosen one is underlined, the house's selection mark
     b  La ruota     the LILLO sizer's wheel, one wheel, beside the ring's own photograph
     c  Il calibro   a jeweller's ring gauge: slide the scale under the needle
     d  Il foglio    one quiet line on the page; the choice opens on a sheet, and the bag bar's
                     "Select a size" opens the same sheet

   Only a face. The theme's selector stays in the page, hidden: every choice here clicks its own size
   button, so the order carries exactly what it always did ("Size": "US 7 / EU 54") and Add to Bag runs
   the same check. Nothing is chosen until the buyer touches it. Sizes, their labels and the EU values
   come from those buttons (the maison's own guide), never from a formula.
   ═══════════════════════════════════════════════════════════════════════════════ */
/* c, the gauge, is Eliau's pick (7 Oct: "either a or C, maybe a bit more C"), so it is the default;
   ?sizer=a|b|d shows another for the visit, ?sizer=0 the theme's own grid. */
var KEY = 'dl.v.sizer';
var v = 'c';
try {
  var q = new URLSearchParams(location.search).get('sizer');
  if (q !== null) sessionStorage.setItem(KEY, /^[a-d0]$/.test(q) ? q : '');
  v = sessionStorage.getItem(KEY) || 'c';
} catch (e) { v = 'c'; }
if (v === '0') return;

var W = {};
try { W = JSON.parse(document.getElementById('dl-sf-words').textContent) || {}; } catch (e) { W = {}; }
function word(k, f) { return W[k] || f; }
var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function $(s, r) { return (r || document).querySelector(s); }
function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
function button(cls) { var b = el('button', cls); b.type = 'button'; return b; }
function sized(u, w) { return /([?&])width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function two(node, a, b) {                               // "US 7" and "EU 54", side by side, no middot (Futura has none)
  node.textContent = '';
  var x = el('span'), y = el('span', 'dl-sf__dim'); x.textContent = a; y.textContent = b;
  node.appendChild(x); node.appendChild(y);
}

/* ── the theme's own size buttons are the only source ─────────────────────────── */
function sizesOf(wrap) {
  return $$('[data-size-pills] .pdp-hero--size-pill', wrap).map(function (p) {
    var us = p.getAttribute('data-us'), eu = p.getAttribute('data-eu');
    var a = $('.pill-us', p), b = $('.pill-eu', p);
    return { us: us, eu: eu, usT: (a ? a.textContent : us).trim(), euT: (b ? b.textContent : eu).trim(),
             whole: parseFloat(us) % 1 === 0, pill: p };
  });
}
function chosenIndex(wrap, sizes) {
  for (var i = 0; i < sizes.length; i++) if (sizes[i].pill.classList.contains('is-selected')) return i;
  var input = $('[data-ring-size]', wrap), m = input && /US\s*([\d.]+)/.exec(input.value || '');
  if (m) for (var k = 0; k < sizes.length; k++) if (sizes[k].us === m[1]) return k;
  return null;
}
function choose(wrap, s) {
  s.pill.click();                                         // the theme's own handler: hidden input, label, error, list
  if (s.pill.classList.contains('is-selected')) return;
  /* not wired (yet): set exactly what that handler sets, which is what Add to Bag reads */
  $$('[data-size-pills] .pdp-hero--size-pill', wrap).forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
  s.pill.classList.add('is-selected'); s.pill.setAttribute('aria-checked', 'true');
  var input = $('[data-ring-size]', wrap); if (input) input.value = 'US ' + s.us + ' / EU ' + s.eu;
  wrap.classList.remove('has-error');
}
function unitOf(wrap) { return wrap.getAttribute('data-unit') === 'EU' ? 'EU' : 'US'; }
function shown(s, unit) { return unit === 'EU' ? s.euT : s.usT; }
function other(s, unit) { return unit === 'EU' ? 'US ' + s.usT : 'EU ' + s.euT; }
function label(s) { return 'US ' + s.usT + ', EU ' + s.euT; }

/* ── a list that snaps: once the buyer moves it, the item that settles at the centre is chosen ── */
function snapper(box, items, axis, onPick, onMove) {
  var touched = false, timer = 0, last = null;
  function centreOf(e) { return axis === 'x' ? e.offsetLeft + e.offsetWidth / 2 : e.offsetTop + e.offsetHeight / 2; }
  function nearest() {
    var c = axis === 'x' ? box.scrollLeft + box.clientWidth / 2 : box.scrollTop + box.clientHeight / 2, best = 0, bd = Infinity;
    for (var i = 0; i < items.length; i++) { var d = Math.abs(centreOf(items[i]) - c); if (d < bd) { bd = d; best = i; } }
    return best;
  }
  function settle() { if (!touched) return; var i = nearest(); if (i !== last) { last = i; onPick(i); } }
  ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { box.addEventListener(ev, function () { touched = true; }, { passive: true }); });
  box.addEventListener('scroll', function () {
    if (touched && onMove) onMove(nearest());
    clearTimeout(timer); timer = setTimeout(settle, 140);
  }, { passive: true });
  if ('onscrollend' in window) box.addEventListener('scrollend', settle);
  var api = {
    to: function (i, smooth) {
      var c = centreOf(items[i]), o = { behavior: smooth && !RM ? 'smooth' : 'auto' };
      if (axis === 'x') o.left = c - box.clientWidth / 2; else o.top = c - box.clientHeight / 2;
      box.scrollTo(o);
    },
    mark: function (i) { last = i; }
  };
  box.addEventListener('keydown', function (e) {
    var k = e.key, step = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : (k === 'ArrowUp' || k === 'ArrowLeft') ? -1 : 0;
    if (!step) return;
    e.preventDefault(); touched = true;
    var i = Math.max(0, Math.min(items.length - 1, (last == null ? nearest() : last) + step));
    last = i; onPick(i); api.to(i, true);
  });
  return api;
}

/* ── a · one line of numbers ───────────────────────────────────────────────────── */
function line(ctx, host) {
  var row = el('div', 'dl-sf__row');
  row.setAttribute('role', 'radiogroup'); row.setAttribute('aria-label', word('selectYour', 'Select your size'));
  var opts = ctx.sizes.map(function (s, i) {
    var b = button('dl-sf__o'); b.setAttribute('role', 'radio'); b.appendChild(el('span', 'dl-sf__n'));
    b.addEventListener('click', function () { ctx.pick(i); centre(i, true); });
    row.appendChild(b); return b;
  });
  var hint = el('p', 'dl-sf__hint'); hint.setAttribute('aria-live', 'polite');
  host.appendChild(row); host.appendChild(hint);
  function centre(i, smooth) {
    var b = opts[i]; row.scrollTo({ left: b.offsetLeft + b.offsetWidth / 2 - row.clientWidth / 2, behavior: smooth && !RM ? 'smooth' : 'auto' });
  }
  return {
    render: function (st) {
      opts.forEach(function (b, i) {
        var s = ctx.sizes[i], on = st.i === i;
        b.firstChild.textContent = shown(s, st.unit); b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false'); b.setAttribute('aria-label', label(s));
      });
      hint.textContent = st.i == null ? '' : other(ctx.sizes[st.i], st.unit);
    },
    reveal: function (st, smooth) { centre(st.i != null ? st.i : ctx.home, smooth); }
  };
}

/* ── b (and inside d) · the wheel, beside the ring's own photograph ───────────── */
function wheel(ctx, host) {
  var card = el('div', 'dl-sf__card');
  var pic = el('div', 'dl-sf__pic'), img = el('img'); img.alt = ''; pic.appendChild(img);
  var wl = el('div', 'dl-sf__wheel'), lens = el('div', 'dl-sf__lens'), strip = el('div', 'dl-sf__strip');
  lens.setAttribute('aria-hidden', 'true');
  strip.tabIndex = 0; strip.setAttribute('role', 'radiogroup'); strip.setAttribute('aria-label', word('selectYour', 'Select your size'));
  var rows = ctx.sizes.map(function (s, i) {
    var r = button('dl-sf__r'); r.tabIndex = -1; r.setAttribute('role', 'radio'); r.appendChild(el('span', 'dl-sf__n'));
    r.addEventListener('click', function () { ctx.pick(i); sn.mark(i); sn.to(i, true); });
    strip.appendChild(r); return r;
  });
  wl.appendChild(lens); wl.appendChild(strip); card.appendChild(pic); card.appendChild(wl); host.appendChild(card);
  var hint = el('p', 'dl-sf__hint'); hint.setAttribute('aria-live', 'polite'); host.appendChild(hint);
  var sn = snapper(strip, rows, 'y', function (i) { ctx.pick(i); });
  return {
    render: function (st) {
      rows.forEach(function (r, i) {
        var s = ctx.sizes[i], on = st.i === i;
        r.firstChild.textContent = shown(s, st.unit); r.classList.toggle('is-on', on);
        r.setAttribute('aria-checked', on ? 'true' : 'false'); r.setAttribute('aria-label', label(s));
      });
      card.classList.toggle('is-set', st.i != null);
      hint.textContent = st.i == null ? '' : other(ctx.sizes[st.i], st.unit);
      var src = ctx.photo(); if (src && img.getAttribute('src') !== src) img.src = src;
    },
    reveal: function (st, smooth) { sn.mark(st.i); sn.to(st.i != null ? st.i : ctx.home, smooth); },
    focus: function () { try { strip.focus({ preventScroll: true }); } catch (e) { strip.focus(); } }
  };
}

/* ── c · the ring gauge ────────────────────────────────────────────────────────── */
function gauge(ctx, host) {
  var read = el('div', 'dl-sf__read'), big = el('span', 'dl-sf__big'), small = el('span', 'dl-sf__small');
  read.setAttribute('aria-live', 'polite'); read.appendChild(big); read.appendChild(small);
  var g = el('div', 'dl-sf__gauge'), scale = el('div', 'dl-sf__scale'), needle = el('span', 'dl-sf__needle');
  needle.setAttribute('aria-hidden', 'true');
  scale.tabIndex = 0; scale.setAttribute('role', 'radiogroup'); scale.setAttribute('aria-label', word('selectYour', 'Select your size'));
  var ticks = ctx.sizes.map(function (s, i) {
    var t = button('dl-sf__t' + (s.whole ? ' is-whole' : '')); t.tabIndex = -1; t.setAttribute('role', 'radio');
    t.appendChild(el('i')); t.appendChild(el('span', 'dl-sf__tn'));
    t.addEventListener('click', function () { preview = null; ctx.pick(i); sn.mark(i); sn.to(i, true); });
    scale.appendChild(t); return t;
  });
  g.appendChild(scale); g.appendChild(needle); host.appendChild(read); host.appendChild(g);
  var preview = null, lastSt = null;
  var sn = snapper(scale, ticks, 'x', function (i) { preview = null; ctx.pick(i); }, function (i) { preview = i; paint(lastSt); });
  function paint(st) {
    if (!st) return;
    var i = preview != null ? preview : st.i;
    read.classList.toggle('is-preview', preview != null && preview !== st.i);
    read.classList.toggle('is-empty', i == null);
    if (i == null) { big.textContent = ''; small.textContent = word('select', 'Select a size'); return; }
    var s = ctx.sizes[i]; big.textContent = shown(s, st.unit); small.textContent = other(s, st.unit);
  }
  return {
    render: function (st) {
      lastSt = st;
      ticks.forEach(function (t, i) {
        var s = ctx.sizes[i], on = st.i === i;
        t.lastChild.textContent = shown(s, st.unit); t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false'); t.setAttribute('aria-label', label(s));
      });
      paint(st);
    },
    reveal: function (st, smooth) { sn.mark(st.i); sn.to(st.i != null ? st.i : ctx.home, smooth); }
  };
}

/* ── d · one line on the page, the choice on a sheet ───────────────────────────── */
var sheetEl = null;
function sheet(ctx, host) {
  var open = button('dl-sf__open'); open.setAttribute('aria-haspopup', 'dialog');
  var val = el('span', 'dl-sf__val'); open.appendChild(val);
  open.insertAdjacentHTML('beforeend', '<svg class="dl-sf__chev" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1.5L6 6.5L11 1.5"/></svg>');
  host.appendChild(open);
  if (sheetEl) sheetEl.remove();
  var sh = sheetEl = el('div', 'dl-sf-sheet');
  sh.hidden = true; sh.setAttribute('role', 'dialog'); sh.setAttribute('aria-modal', 'true');
  sh.setAttribute('aria-label', word('selectYour', 'Select your size')); sh.setAttribute('data-lenis-prevent', '');
  sh.innerHTML = '<div class="dl-sf-sheet__scrim" data-sf-x></div><div class="dl-sf-sheet__panel">'
    + '<div class="dl-sf-sheet__top"><span class="dl-sf-sheet__t"></span><button type="button" class="dl-sf-sheet__x" data-sf-x>'
    + '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg></button></div>'
    + '<div class="dl-sf-sheet__body"></div><button type="button" class="dl-sf-sheet__done"></button></div>';
  $('.dl-sf-sheet__t', sh).textContent = word('selectYour', 'Select your size');
  $('.dl-sf-sheet__x', sh).setAttribute('aria-label', word('close', 'Close'));
  var done = $('.dl-sf-sheet__done', sh); done.textContent = word('done', 'Done');
  document.body.appendChild(sh);
  var wh = wheel(ctx, $('.dl-sf-sheet__body', sh));
  var opener = null;
  function show() {
    if (!sh.hidden) return;
    opener = document.activeElement;
    sh.hidden = false; document.documentElement.style.overflow = 'hidden';
    wh.reveal(ctx.state(), false); wh.focus();
  }
  function hide() {
    if (sh.hidden) return;
    sh.hidden = true; document.documentElement.style.overflow = '';
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  }
  open.addEventListener('click', show);
  $$('[data-sf-x]', sh).forEach(function (x) { x.addEventListener('click', hide); });
  done.addEventListener('click', function () { if (ctx.state().i == null) { wh.focus(); return; } hide(); });
  sh.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); hide(); } });
  return {
    render: function (st) {
      open.classList.toggle('is-empty', st.i == null);
      if (st.i == null) val.textContent = word('select', 'Select a size');
      else { var s = ctx.sizes[st.i]; two(val, st.unit === 'EU' ? 'EU ' + s.euT : 'US ' + s.usT, other(s, st.unit)); }
      done.setAttribute('aria-disabled', st.i == null ? 'true' : 'false');
      wh.render(st);
    },
    reveal: function (st, smooth) { if (!sh.hidden) wh.reveal(st, smooth); },
    show: show
  };
}

/* ── start ─────────────────────────────────────────────────────────────────────── */
function make(wrap) {
  var sizes = sizesOf(wrap);
  if (!sizes.length) return;
  var home = 0; sizes.forEach(function (s, i) { if (s.us === '7') home = i; });   // where an untouched wheel rests
  var host = el('div', 'dl-sf dl-sf--' + v), face = null;
  var ctx = {
    sizes: sizes, home: home,
    state: function () { return { i: chosenIndex(wrap, sizes), unit: unitOf(wrap) }; },
    pick: function (i) { choose(wrap, sizes[i]); if (face) face.render(ctx.state()); },
    photo: function () {
      var f = document.querySelector('[data-pdp-images] img.pdp-hero--main-image');
      var u = f && (f.getAttribute('src') || '');
      return u ? sized(u, 480) : '';
    }
  };
  face = v === 'a' ? line(ctx, host) : v === 'b' ? wheel(ctx, host) : v === 'c' ? gauge(ctx, host) : sheet(ctx, host);
  wrap.classList.add('dl-sf-on');
  wrap.insertBefore(host, $('[data-size-trigger]', wrap));
  face.render(ctx.state());
  face.reveal(ctx.state(), false);
  var panel = $('[data-size-panel]', wrap), trigger = $('[data-size-trigger]', wrap);
  new MutationObserver(function () {
    face.render(ctx.state());
    /* The page's own check (Add to Bag, or the bag bar's "Select a size") opens the theme's list, which is
       hidden here: close it and bring the buyer to this one instead. */
    if (panel && panel.classList.contains('is-open')) {
      panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (face.show) face.show(); else if (face.focus) face.focus();
    }
  }).observe(wrap, { subtree: true, attributes: true, attributeFilter: ['class', 'data-unit'] });
}
function boot() {
  var wrap = document.querySelector('[data-size-group] [data-size-selector][data-slot="single"]');
  if (!wrap || wrap.querySelector('.dl-sf')) return;
  make(wrap);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
else setTimeout(boot, 0);
document.addEventListener('snc:pdp:swapped', function () { setTimeout(boot, 0); });
})();
